<template>
    <span class="sf__results__result__status-detail">{{ detail.detailBefore }}<span v-if="detail.detailHighlight" class="sf__results__result__status-timeframe">{{ detail.detailHighlight }}</span>{{ detail.detailAfter }}</span>
</template>

<script>
import {splitStatusDetail} from '../helpers/helpers';

export default {
    props: ['status'],

    computed: {
        detail() {
            if (['in-stock', 'made-to-order'].includes(this.status?.key)) {
                return splitStatusDetail(this.status.detail);
            }

            return { detailBefore: this.status?.detail || '', detailHighlight: '', detailAfter: '' };
        }
    }
};
</script>
